import { render, staticRenderFns } from "./TypesenseSearch.vue?vue&type=template&id=dd8d0cc4"
import script from "./TypesenseSearch.vue?vue&type=script&lang=js"
export * from "./TypesenseSearch.vue?vue&type=script&lang=js"
import style0 from "./TypesenseSearch.vue?vue&type=style&index=0&id=dd8d0cc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports